// import { isMobile } from '@pascal/pascal-core';

import { popupStore } from '@pascal/pascal-core/shared/core/store';
// import { gameDrawer } from '../game/drawers';
import { gameLiveConnection } from '../services';
// import { webGameSceneDrawer } from '../game/drawers/gameDrawer/gameSceneDrawer';crazy-worm-logo

class LiveConnection {
  isConnected = false;

  handleSocketInit() {
    gameLiveConnection
      ?.init()
      .then(() => {
        this.isConnected = true;
        this.connectionInitCallback();
      })
      .catch(() => popupStore.onConnectionError(true));
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          this.connectionInitCallback();
          res();
        });
      });
    });
  }

  connectionInitCallback(isFirst) {
    // webGameSceneDrawer.clearAllGameTracks();
    // gameDrawer
    //   .execute({
    //     mode: isMobile() ? 'mobile' : 'web',
    //     scene: 'Main',
    //     prevScene: null,
    //   })
    //   .then(() => {
    if (this.isConnected) {
      gameLiveConnection.sendGameGetInitialState(isFirst);
    }
    //   });
  }
}

export const liveConnection = new LiveConnection();
